import { createAction } from '@reduxjs/toolkit'
import traceActionsCreator from '../traceActionsCreator'

export const ledgerReportServiceName = 'ledgerReport'
export const ledgerReportActions = traceActionsCreator(ledgerReportServiceName)
export const ledgerReportClearServiceName = 'ledgerReportClear'
export const ledgerReportClearActions = createAction(
  ledgerReportClearServiceName
)
